import { Declaration } from 'store/declarations/declaration';
import { ICS2MessageTypes } from 'store/declarations/enums/common/declaration-types';

export const hasIcs2MasterItems = (declaration: Declaration | undefined) =>
    !!declaration?.ics2ENSDeclaration && declaration.ics2ENSDeclaration.messageType !== ICS2MessageTypes.F50;
